import { AfterViewInit, Directive, ElementRef, HostListener, Input } from '@angular/core';
import * as _ from 'lodash';

@Directive({
  selector: 'input[decimalFormat]',
})
export class DecimalFormatInputDirective implements AfterViewInit {
  private _value: string | null;
  private editMode: boolean = false;

  constructor(private elementRef: ElementRef<HTMLInputElement>) {
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.formatValue(this.elementRef.nativeElement.value);
    }, 10);
  }

  get value(): string | null {
    return this._value;
  }

  @Input('ngModel')
  set value(value: string | null) {
    this._value = value;
    if (this.editMode) {
      return;
    }
    setTimeout(() => {
      this.formatValue(value);
    }, 10);
  }

  private formatValue(value: string | null) {
    if (value !== null && value.length > 0) {
      const formatedValue = this.formatAsDecimal(value);
      this.elementRef.nativeElement.value = formatedValue;
    } else {
      this.elementRef.nativeElement.value = '';
    }
  }

  private unFormatValue() {
    const value = this.elementRef.nativeElement.value;
    this._value = value.replace(/[^\d,-]/g, '');
    if (value) {
      this.elementRef.nativeElement.value = this._value;
    } else {
      this.elementRef.nativeElement.value = '';
    }
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value) {
    this._value = value.replace('.',',').replace(/[^\d,-]/g, '');
  }

  @HostListener('blur')
  onBlur() {
    this.editMode = false;
    this.formatValue(this._value);
  }

  @HostListener('focus')
  onFocus() {
    this.editMode = true;
    this.unFormatValue();
  }

  formatAsDecimal(value: string): string {

    if (_.isNil(value)) {
      return '';
    }

    var parts = value.toString().replace(/\s/g, '').split(/[,\.]+/);

    if (_.isNil(parts[0]) || parts[0] == "") {
      parts[0] = '0';
    }

    parts[0] = _.parseInt(parts[0]).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    parts[1] = _.defaultTo(parts[1], '0').padEnd(2, '0');

    return parts.join(',');
  }

}